const ORDER_SOURCE_LABELS = {
  pos: 'POS',
  shopify: 'Shopify',
  '91app': '91APP',
  shopline: 'Shopline',
  batch_import: '批次匯入',
  lockline_commerce: '商城',
  manual: '手動建立',
};

const PAYMENT_METHOD_LABELS = {
  cash: '現金',
  card: '信用卡',
  credit: '信用卡',
  credit_card: '信用卡',
  debit_card: '金融卡',
  mobile_payment: '行動支付',
  line_pay: 'LINE Pay',
  transfer: '轉帳',
  online: '線上付款',
  ecpay: '綠界付款',
  other: '其他',
};

export function orderSourceLabel(source) {
  if (!source) return '-';
  return ORDER_SOURCE_LABELS[source] || source;
}

export function paymentMethodLabel(method) {
  if (!method) return '-';
  return PAYMENT_METHOD_LABELS[method] || method;
}
